import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  hint,
  error,
  required,
  className = '',
  id,
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className="admin-form-group">
      {label && (
        <label htmlFor={inputId} className={`admin-form-label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`admin-input ${error ? 'error' : ''} ${className}`}
        {...props}
      />
      {hint && !error && <span className="admin-input-hint">{hint}</span>}
      {error && <span className="admin-input-hint" style={{ color: 'var(--admin-error)' }}>{error}</span>}
    </div>
  );
};

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  hint,
  error,
  required,
  className = '',
  id,
  ...props
}) => {
  const textareaId = id || `textarea-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className="admin-form-group">
      {label && (
        <label htmlFor={textareaId} className={`admin-form-label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        className={`admin-textarea ${error ? 'error' : ''} ${className}`}
        {...props}
      />
      {hint && !error && <span className="admin-input-hint">{hint}</span>}
      {error && <span className="admin-input-hint" style={{ color: 'var(--admin-error)' }}>{error}</span>}
    </div>
  );
};

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  options: { value: string; label: string }[];
}

export const Select: React.FC<SelectProps> = ({
  label,
  hint,
  error,
  required,
  options,
  className = '',
  id,
  ...props
}) => {
  const selectId = id || `select-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <div className="admin-form-group">
      {label && (
        <label htmlFor={selectId} className={`admin-form-label ${required ? 'required' : ''}`}>
          {label}
        </label>
      )}
      <select
        id={selectId}
        className={`admin-select ${error ? 'error' : ''} ${className}`}
        {...props}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {hint && !error && <span className="admin-input-hint">{hint}</span>}
      {error && <span className="admin-input-hint" style={{ color: 'var(--admin-error)' }}>{error}</span>}
    </div>
  );
};

export default Input;
